import React, { useState } from 'react';
import { Container, Flex, Box } from '@chakra-ui/react';
import { graphql } from 'gatsby';
import { Layout } from '../components/Layout';
import { SEO } from '../components/SEO';
import { SectionCard } from '../components/SectionCard';
import { SectionTag } from '../components/SectionTag';
import { SwipableContent } from '../components/SwipableContent';

export default function Index({ data: { sanityHomePage: data } }) {
  const { desktopLayout, mobileLayout } = data || {};
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Layout>
      <Container maxWidth='container.xl' display={{ base: 'none', lg: 'block' }}>
        {desktopLayout?.gridRows?.map((row, index) => (
          <Flex
            key={`gridRow-${index}`}
            direction='column'
            gap={30}
            py={{ base: 30, lg: 40 }}
            borderTop={index !== 0 ? '1px solid' : 'none'}
            borderColor='zinc.200'
          >
            {row?.section && (
              <Flex>
                <SectionTag title={row.section} />
              </Flex>
            )}
            <Flex direction={{ base: 'column', lg: 'row' }} gap={{ base: 30, lg: 60 }}>
              {row?.items?.map((column, colIndex) => (
                <Flex
                  key={`gridItem-${colIndex}`}
                  direction='column'
                  gap={30}
                  flex={column.columns}
                  order={{ base: column.title === 'Featured' ? -1 : 0, lg: '1' }}
                  onMouseEnter={() => (column.title !== 'Featured' ? setIsHovered(true) : null)}
                  onMouseLeave={() => (column.title !== 'Featured' ? setIsHovered(false) : null)}
                >
                  {column?.section && (
                    <Flex>
                      <SectionTag title={column.section} />
                    </Flex>
                  )}
                  {column?.items?.map((item, itemIndex) => (
                    <SectionCard
                      data={item}
                      key={`gridSection-${colIndex}-${itemIndex}`}
                      useWindowMouseEvents={!isHovered}
                    />
                  ))}
                </Flex>
              ))}
            </Flex>
          </Flex>
        ))}
      </Container>

      <Box display={{ base: 'block', lg: 'none' }}>
        {mobileLayout?.map((row, index) => (
          <Flex
            direction='column'
            gap={20}
            key={`gridRow-${index}`}
            borderTop={index !== 0 ? '1px solid' : 'none'}
            borderColor='zinc.200'
            py={20}
          >
            {row?.section && (
              <Flex px={20}>
                <SectionTag title={row.section} />
              </Flex>
            )}
            {row.items[0].items.length === 1 ? (
              <Box px={20}>
                <SectionCard data={row.items[0].items[0]} />
              </Box>
            ) : (
              <SwipableContent items={row.items[0].items} />
            )}
          </Flex>
        ))}
      </Box>
    </Layout>
  );
}

export const query = graphql`
  query HomePage {
    sanityHomePage {
      desktopLayout: _rawDesktopLayout(resolveReferences: { maxDepth: 10 })
      mobileLayout: _rawMobileLayout(resolveReferences: { maxDepth: 10 })
    }
  }
`;

export const Head = () => <SEO title='IMF Annual Report 2024' />;
